import React from 'react';
import moment from 'moment';
import { Box } from '@mui/material';
const FlightDetailRowTBO = ({ item }) => {
	return (
		<Box
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				padding: 8,
				border: '1px solid #333',
			}}>
			<Box>
				<span>
					{item.Airline.AirlineCode}-{item.Airline.FlightNumber}
				</span>
				<br></br>
				<span>{item.Airline.AirlineName}</span>
			</Box>
			<Box>
				<span>{item.Airline.FareClass}</span>
			</Box>
			<Box>
				<span>Non Stop</span>
			</Box>
			<Box>
				<span>{`${moment(item.Origin.DepTime).format('DD-MM-YYYY')} ${
					item.Origin.DepTime.split('T')[1]
				}`}</span>
				<br></br>
				<span>{`${item.Origin.Airport.AirportName} (${item.Origin.Airport.AirportCode})`}</span>
			</Box>
			<Box>
				<span>{`${moment(item.Destination.ArrTime).format('DD-MM-YYYY')} ${
					item.Destination.ArrTime.split('T')[1]
				}`}</span>
				<br></br>
				<span>{`${item.Destination.Airport.AirportName} (${item.Destination.Airport.AirportCode})`}</span>
			</Box>
			<Box>
				<span>{`${item.Duration} min`}</span>
			</Box>
			<Box>
				<span>{`${item?.Baggage} || ${item?.CabinBaggage} `}</span>
			</Box>
		</Box>
	);
};

export default FlightDetailRowTBO;
